import { useRouterState } from "@tanstack/react-router";

/** Indicador leve durante transições, sem spinner central para não duplicar o carregamento das janelas. */
export function CarregandoNavegacao() {
  const isLoading = useRouterState({ select: (s) => s.isLoading });
  if (!isLoading) return null;

  return (
    <div className="pointer-events-none fixed left-0 right-0 top-0 z-50 h-1 overflow-hidden bg-primary/20">
      <div className="h-full w-1/3 animate-pulse bg-primary" />
      <span className="sr-only">Carregando Navegação...</span>
    </div>
  );
}
